import { useScrollToTop } from '../hooks/useScrollToTop';

export const ScrollToTop = ({ children }: { children: React.ReactNode }) => {
  useScrollToTop();
  return <>{children}</>;
}; 